
export const defaultSelectedWarehouse = () => {
  return {
    id: null,
    city_id: "",
    country_id:1,
    code: "",
    description: "",
    address: "",
    latitude: "",
    length: "",
    telephone: "",
    email: "",
    seller_id: null,
    observation: "",
    state: 1,
    excluded_taxes: 0,
    branchoffice_id: "",
    creation_date: new Date(),
    other_telephones: null,
    payment_type_id: null,
    discount_percentage: null,
    zone_id:null,
    types_negotiation_portfolio: null,
    city:{},
    zone_despatch_id:null,
    ret_ica_provider_account_id:null,
    ret_ica_account_id:null,
    ret_ica_lub_account_id:null,
    retIcaAccount: {},
    retIcaLubAccount: {},
    retIcaProvideerAccount: {},
    ret_fue_provider_account_id:null,
    ret_fue_account_id:null,
    ret_fue_lub_account_id:null,
    ret_fue_lub_provider_account_id:null,
    retFueAccount: {},
    retFueLubAccount: {},
    retFueLubProviderAccount: {},
    retFueProviderAccount: {},
    ret_fue_serv_provider_account_id:null,
    ret_fue_serv_account_id:null,
    retFueServAccount: {},
    retFueServProviderAccount: {},
    ret_ica_serv_account_id:null,
    retIcaServAccount: {},
    ret_ica_serv_provider_account_id:null,
    retIcaServProviderAccount: {},
    bomberil_account_id_customer: null,
    bomberil_account_id_provider: null,
    bomberilCustomerAccount: {},
    bomberilProviderAccount: {},
    no_base_value: false,
    no_base_value_ret_ica_provider: false,
    no_base_value_ret_ica_serv_provider: false,
    no_base_value_ret_ica_customer: false,
    no_base_value_ret_ica_serv_customer: false,
    no_base_value_ret_fue_provider: false,
    no_base_value_ret_fue_serv_provider: false,
    no_base_value_ret_fue_customer: false,
    no_base_value_ret_fue_lub_customer: false,
    no_base_value_ret_fue_lub_provider: false,
    no_base_value_ret_fue_serv_customer: false,
    no_base_value_ret_ica_lub_customer: false,
    no_ret_fue_apply: false,
    no_ret_ica_apply: false,
    no_ret_iva_apply: false,
    no_ret_fue_apply_provider: false,
    no_ret_ica_apply_provider: false,
    no_ret_iva_apply_provider: false
  };
};

export default {
  accounts:[],
  departments:[],
  cities: [],
  warehouses: [],
  selectedWarehouse: defaultSelectedWarehouse(),
  error: false,
  errorMessage: "",
  actionWarehouse: "create",
  citiesWarehouses: [],
  sellers: [],
  paymentMethods: [],
  types_negotiation_portfolio: [],
  zones:[],
  zones_despatch:[],
  sellersByRole: []
};



// WEBPACK FOOTER //
// ./src/modules/contacts-warehouses/state.js